import { render, staticRenderFns } from "./MainFnnclInfo.vue?vue&type=template&id=279e8064"
import script from "./MainFnnclInfo.vue?vue&type=script&lang=js"
export * from "./MainFnnclInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/devopsfs01/workspace/dev-rca-mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('279e8064')) {
      api.createRecord('279e8064', component.options)
    } else {
      api.reload('279e8064', component.options)
    }
    module.hot.accept("./MainFnnclInfo.vue?vue&type=template&id=279e8064", function () {
      api.rerender('279e8064', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/main/MainFnnclInfo.vue"
export default component.exports